import {Entity} from '@s-ui/domain'

export class AssistantChatEntity extends Entity {
  #chatId
  #messageId
  #blocks
  #exists

  constructor({chatId, messageId, blocks, exists = true}) {
    super()
    this.#chatId = chatId
    this.#messageId = messageId
    this.#blocks = blocks
    this.#exists = exists
  }

  static create({chatId, messageId, blocks}) {
    return new AssistantChatEntity({chatId, messageId, blocks})
  }

  static createDefault({chatId}) {
    return new AssistantChatEntity({chatId, exists: true, blocks: [], messageId: null})
  }

  static createFromChatApiResponse(chatId, chatData) {
    return new AssistantChatEntity({
      chatId,
      messageId: chatData.messageId,
      blocks: chatData.blocks
    })
  }

  toJSON() {
    return {
      chatId: this.#chatId,
      messageId: this.#messageId,
      blocks: this.#blocks,
      exists: this.#exists
    }
  }
}
